import { z } from 'zod';

export const contactStatementKindSchema = z.enum(['customer', 'vendor']);
export type ContactStatementKind = z.infer<typeof contactStatementKindSchema>;

export const contactStatementQuerySchema = z.object({
  from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
});
export type ContactStatementQuery = z.infer<typeof contactStatementQuerySchema>;

export interface ContactStatementLine {
  date: string;
  type: 'invoice' | 'bill' | 'payment';
  ref: string;
  charge: string; // increases the balance (invoice/bill)
  credit: string; // reduces the balance (payment)
  balance: string; // running balance
}

export interface ContactStatementResponse {
  contactId: string;
  contactName: string;
  kind: ContactStatementKind;
  from: string;
  to: string;
  openingBalance: string;
  closingBalance: string;
  totalCharges: string;
  totalCredits: string;
  lines: ContactStatementLine[];
}
